import React from 'react'

const BreakRules = () => {
    return (
        <>BreakRules mobile</>
    )
}

export { BreakRules }